import { GridRenderCellParams } from '@mui/x-data-grid';
import { TimeSheetGridRow } from './time-sheet.types';

const getTotalWorkingDays = (payload: TimeSheetGridRow): number => {
  const { id, name, isClosed, closedWorkShiftsCount, daysSum, hoursSum, closePeriodAction, ...values } = payload;
  return Object.values(values).reduce((acc: number, curr)=> Number(curr) > 0 ? acc + 1: acc, 0);
};

export const DaysSumCell = (props: GridRenderCellParams<TimeSheetGridRow>) => {
  const totalWorkingDays = getTotalWorkingDays(props.row as TimeSheetGridRow);
  return (<span>{totalWorkingDays}</span>);
};
